/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Land_TypeInputs */

const en_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land Type`)
};

const es_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de terreno`)
};

const fr_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de terrain`)
};

const de_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundstücksart`)
};

const ja_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地の種類`)
};

const zh_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`土地类型`)
};

const ar_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الأرض`)
};

const id_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Tanah`)
};

const it_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Terreno`)
};

const ru_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип земельного участка`)
};

const pt_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Terreno`)
};

const ko_field_land_type = /** @type {(inputs: Field_Land_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토지 용도`)
};

/**
* | output |
* | --- |
* | "Land Type" |
*
* @param {Field_Land_TypeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_land_type = /** @type {((inputs?: Field_Land_TypeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Land_TypeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_land_type(inputs)
	if (locale === "es") return es_field_land_type(inputs)
	if (locale === "fr") return fr_field_land_type(inputs)
	if (locale === "de") return de_field_land_type(inputs)
	if (locale === "ja") return ja_field_land_type(inputs)
	if (locale === "zh") return zh_field_land_type(inputs)
	if (locale === "ar") return ar_field_land_type(inputs)
	if (locale === "id") return id_field_land_type(inputs)
	if (locale === "it") return it_field_land_type(inputs)
	if (locale === "ru") return ru_field_land_type(inputs)
	if (locale === "pt") return pt_field_land_type(inputs)
	return ko_field_land_type(inputs)
});